import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@atoms';
import { BlockedAttendeeWrapper } from './layout';
import messages from './messages';

export const BlockedAttendee = ({ attendee: { email, id }, unblockAttendee }) => (
  <BlockedAttendeeWrapper>
    <div>{email}</div>
    <Button
      small
      onClick={() => {
        if (window.confirm(`Unblock ${email}?`)) unblockAttendee(id);
      }}
    >
      <FormattedMessage {...messages.unblock} />
    </Button>
  </BlockedAttendeeWrapper>
);

BlockedAttendee.propTypes = {
  attendee: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  unblockAttendee: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./components/pages/BlockedAttendeesPage/BlockedAttendee.js